import '../templates/components/wishlist-button/wishlist-button.js';
import { wishlistService } from './service/wishlist-service.js';
import { wishlistHeaderCountService } from './service/wishlist-header-count-service.js';

wishlistHeaderCountService.init();
wishlistService.init();
